declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export function loadGTM(): void {
  try {
    const containerId = import.meta.env.VITE_GTM_CONTAINER_ID as string | undefined;
    if (!containerId || containerId.charAt(0) === "%") return;
    if (document.getElementById("gtm-script")) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const script = document.createElement("script");
    script.id = "gtm-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
    const first = document.getElementsByTagName("script")[0];
    first.parentNode!.insertBefore(script, first);
    const noscript = document.createElement("noscript");
    noscript.id = "gtm-noscript";
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  } catch {
    // analytics must never break the page
  }
}

export function pushEvent(event: string, data?: Record<string, unknown>): void {
  try {
    if (typeof window === "undefined") return;
    if (!Array.isArray(window.dataLayer)) {
      window.dataLayer = [];
    }
    window.dataLayer.push({ event, ...data });
  } catch {
    // analytics must never break the page
  }
}
